import { render, staticRenderFns } from "./footerbar.vue?vue&type=template&id=17d702f3&scoped=true&"
import script from "./footerbar.vue?vue&type=script&lang=js&"
export * from "./footerbar.vue?vue&type=script&lang=js&"
import style0 from "./footerbar.vue?vue&type=style&index=0&id=17d702f3&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17d702f3",
  null
  
)

export default component.exports